export default function Features() {
  const features = [
    {
      icon: 'ri-file-shield-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activity is your business alone.',
      link: '#'
    },
    {
      icon: 'ri-shut-down-line',
      title: 'Kill Switch',
      description: 'Automatically disconnects your internet if VPN connection drops, ensuring your data never leaks.',
      link: '#'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multi-Device Support',
      description: 'Protect up to 10 devices simultaneously with a single account across all platforms.',
      link: '#'
    },
    {
      icon: 'ri-earth-line',
      title: 'Global Servers',
      description: 'Access content from anywhere with our network of high-speed servers in over 60 countries.',
      link: '#'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'High-Speed Connection',
      description: 'Enjoy unlimited bandwidth with optimized servers for streaming, gaming, and browsing.',
      link: '#'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Our expert team is always available to help you with any questions or technical issues.',
      link: '#'
    }
  ];

  return (
    <section id="features" className="py-40 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="mb-4">
            <span className="text-purple-600 text-sm font-semibold tracking-widest uppercase">
              FEATURES
            </span>
          </div>
          
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Why Choose Our VPN
          </h2>
          
          <div className="flex items-center justify-center gap-2 mt-8">
            <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
            <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
            <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-10 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed mb-6">
                {feature.description}
              </p>
              
              <a 
                href={feature.link}
                className="text-purple-600 font-medium flex items-center gap-2 hover:gap-3 transition-all cursor-pointer"
              >
                Learn more
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
